import React from "react";
import { Offcanvas } from "react-bootstrap";
import { XLg } from "react-bootstrap-icons";
interface offCanvasProps {
  handleClose: () => void;
  show: boolean;
  title: string;
  children?: React.ReactNode;
  headerChildren?: React.ReactNode;
}

export default function OffCanvas(props: offCanvasProps) {
  const { handleClose, show, children, title, headerChildren } = props;

  return (
    <>
      <Offcanvas
        show={show}
        // backdrop="static"
        onHide={handleClose}
        className="offcanvas offcanvas-end"
        placement="end"
      >
        <Offcanvas.Header className="offcanvas-header border-bottom d-flex justify-content-between">
          <h5 className="offcanvas-title" id="offcanvasRightLabel">
            {title}
          </h5>
          <div className="d-flex align-items-center">
            {headerChildren}
            <button
              type="button"
              className="btn-close sph-close py-0 d-flex align-items-center"
              aria-label="Close"
              onClick={handleClose}
            >
              <XLg className="offcanvas-close-icon" />
            </button>
          </div>
        </Offcanvas.Header>
        <Offcanvas.Body className="pb-0 d-flex flex-column">{children}</Offcanvas.Body>
      </Offcanvas>
    </>
  );
}
